import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';

import { ContextService } from 'src/app/core/services/context/context.service';
import { TrackingAction } from 'src/app/core/services/tracking/models/tracking-action.enum';
import { ScriptParams } from 'src/app/utils/functions/load-external-script';
import { filterTruthy } from 'src/app/utils/functions/rx-filters';
import { UPSELLING_RECOMMENDATION_SCRIPT_URLS } from 'src/app/utils/global-constants';

import { ConfigurationService } from '../configuration.service';

interface RecommendationVehicleChange {
  added: string | null;
  removed: string | null;
  vehicleId: string; // we actually do not make use of the full vehicle id
}

/**
 * Component of a lazy loaded module => no selector
 */
@Component({
  templateUrl: './upselling-recommendation.component.html',
  styleUrls: ['./upselling-recommendation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpsellingRecommendationComponent {
  public vehicleId$: Observable<string> = this.contextService.vehicleId$.pipe(filterTruthy());

  public constructor(
    private readonly contextService: ContextService,
    private readonly configurationService: ConfigurationService
  ) {}

  public get scriptParamsArray(): ScriptParams[] {
    return UPSELLING_RECOMMENDATION_SCRIPT_URLS.map(scriptUrl => ({ scriptUrl, isModule: true }));
  }

  public onVehicleChange(event: CustomEvent): void {
    const change: RecommendationVehicleChange = event.detail[0];

    if (change.added) {
      this.configurationService.addSelectable(change.added, TrackingAction.ItemTile);
    } else if (change.removed) {
      this.configurationService.removeSelectable(change.removed, TrackingAction.ItemTile);
    }
  }
}
